import { Suspense, useState } from "react";

import Card from "shared/ui/card";
import { concatClassnames } from "shared/utils/concatClassnames";
import BusinessDoorOptions from "widgets/business-configurator/door-options";
import BusinessDoorOptionsFooter from "widgets/business-configurator/door-options-footer";
import { DoorOptionsUSPHeader } from "widgets/configurator/door-options-usp-header";
import OptionModal, {
  OptionModalState,
} from "widgets/configurator/option-modal";
import WhatsAppCard from "widgets/shared/whatsapp-widget/WhatsAppCard";

interface BusinessConfiguratorOptionsProps {
  className?: string;
}
const BusinessConfiguratorOptions = ({
  className = "",
}: BusinessConfiguratorOptionsProps) => {
  const [optionModalState, setOptionModalState] = useState<OptionModalState>({
    isOpen: false,
    heading: "",
    description: "",
  });

  return (
    <Suspense fallback={null}>
      <section className={concatClassnames(className)}>
        <Card className="custom-scroll-container gg-relative">
          <DoorOptionsUSPHeader />

          <WhatsAppCard />

          <BusinessDoorOptions setOptionModalState={setOptionModalState} />
          <footer className="gg-sticky gg-bottom-0">
            <BusinessDoorOptionsFooter />
          </footer>
        </Card>

        <OptionModal
          modalState={optionModalState}
          setModalState={setOptionModalState}
        />
      </section>
    </Suspense>
  );
};
export default BusinessConfiguratorOptions;
